import { create } from 'zustand'
import { persist } from 'zustand/middleware'

export interface Agent {
  id: number
  alias: string
  name: string
  role: string
  is_active: boolean
  chat_internal_enabled: boolean
}

interface AuthState {
  isAuthenticated: boolean
  agent: Agent | null
  sessionToken: string | null
  login: (alias: string, password: string) => Promise<void>
  logout: () => Promise<void>
  setAgent: (agent: Agent) => void
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      isAuthenticated: false,
      agent: null,
      sessionToken: null,

      login: async (alias: string, password: string) => {
        const response = await fetch('/auth/login', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          credentials: 'include',
          body: JSON.stringify({ alias, password, email: '' }),
        })

        if (!response.ok) {
          throw new Error('Login failed')
        }

        const loginData = await response.json()
        if (!loginData.ok) {
          throw new Error('Login failed')
        }

        // Obtener datos del agente autenticado
        const meResponse = await fetch('/auth/me', {
          method: 'GET',
          credentials: 'include',
        })

        if (!meResponse.ok) {
          throw new Error('Failed to get agent data')
        }

        const agentData = await meResponse.json()
        
        set({
          isAuthenticated: true,
          agent: {
            id: agentData.id,
            alias: agentData.alias,
            name: agentData.name,
            role: agentData.role,
            is_active: agentData.active,
            chat_internal_enabled: agentData.chat_internal_enabled,
          },
          sessionToken: null, // La sesión se maneja via cookie
        })
      },

      logout: async () => {
        try {
          await fetch('/auth/logout', {
            method: 'POST',
            credentials: 'include',
          })
        } catch (error) {
          console.error('Logout request failed:', error)
          // Continuar con limpieza de estado incluso si falla el request
        }

        set({
          isAuthenticated: false,
          agent: null,
          sessionToken: null,
        })
      },

      setAgent: (agent: Agent) => {
        set({ agent })
      },
    }),
    {
      name: 'auth-storage',
      partialize: (state) => ({
        isAuthenticated: state.isAuthenticated,
        agent: state.agent,
      }),
    }
  )
)
